import styled from 'styled-components'
import Link from 'next/link'
import { useInitalProjects } from 'querys/projects'
import { Typography } from 'common/typography'

const ProjectsBannerStyled = styled.div`
  overflow: hidden;
  display: flex;
  margin: 72px auto 0;
  color: var(--basePrimary);
  background-image: url(${({ background }) => `'${background}'`});
  background-color: #E0FCFF;
  gap: 0px;
  background-size: 50%;
  background-repeat: no-repeat;
  justify-content: flex-end;
  cursor: pointer;
  padding: 16px;
  position: relative;
  div {
    flex: 1;
  }
  h2 {
    max-width: 486px;
    margin-block-end: 8px;
  }
  .banner-img {
    margin: 16px 0;
    img {
      max-width: 100%;
    }
  }
  p {
    font-weight: 400;
    color: var(--primary90);
    text-decoration: underline;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    inset: 0;
    background-image: linear-gradient(86.67deg, rgba(224, 252, 255, 0.05) 34.6%, #DFFBFF 67.87%, #DFFBFF 93.42%), linear-gradient(89.91deg, rgba(223, 251, 255, 0.05) 46.82%, #DFFBFF 64.56%);
    background-size: 140%;
    background-position: right;
  }
  .banner-content {
    position: relative;
  }
  @media(min-width: 768px) {
    gap: 16px;
    margin: 0;
    padding: 52px 64px;
    position: relative;
    .banner-img {
      position: absolute;
      margin: 0;
      top: 0;
      left: 560px;
      bottom: 0px;
      width: 400px;
    }
  }
  @media(min-width: 1366px) {
    .banner-img {
      position: absolute;
      margin: 0;
      left: auto;
      width: 500px;
      right: 0;
      top: -35px;
      img {
        width: 100%;
      }
    }
  }
`

function ProjectsBanner() {
  const { data } = useInitalProjects()
  if (!data) return null
  const { results } = data
  const { slug, title, thumb_image } = results[0]
  return (
    <Link href={`/proyectos/${slug}`} passHref>
      <ProjectsBannerStyled role="complementary" aria-labelledby="recent-project" background={thumb_image}>
        <div />
        <div className="banner-content">
          <Typography small="p2Bold" large="headline4" as="h2" id="recent-project">
            {title}
          </Typography>
          <Typography small="smallRegular" large="headline6">
            Conoce nuestro nuevo proyecto
          </Typography>
        </div>
      </ProjectsBannerStyled>
    </Link>
  )
}

export default ProjectsBanner
